import React, { useState } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Stack,
  ButtonGroup,
  Button,
  Popover,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import { styled } from "@mui/system";
import UpdateManualInput from "../components/update-data-modal-feature/update-manual-input";
import UploadExcelSheet from "../components/update-data-modal-feature/upload-excel-sheet";

const StyledModal = styled(Modal)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ModalContent = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "60%",
  maxWidth: "1200px",
  [theme.breakpoints.down("lg")]: {
    width: "70%",
  },
  [theme.breakpoints.down("md")]: {
    width: "90%",
  },
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[24],
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const UpdateDataModal = ({ open, handleClose, setData }) => {
  const tabMap = {
    MANUAL_INPUT: "Manual Input",
    EXCEL_UPLOAD: "Excel Upload",
  };

  const [activeTab, setActiveTab] = useState("MANUAL_INPUT");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const openInfo = Boolean(anchorEl);

  return (
    <StyledModal
      open={open}
      onClose={handleClose}
      aria-labelledby="update-data-modal-title"
    >
      <ModalContent>
        <CloseButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        {/* Information */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <Typography id="update-data-modal-title" variant="h6" component="h2">
            Update Data
          </Typography>
          <IconButton
            size="small"
            onClick={handleInfoClick}
            aria-label="information"
          >
            <InfoIcon fontSize="small" />
          </IconButton>
          <Popover
            open={openInfo}
            anchorEl={anchorEl}
            onClose={handleInfoClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Box sx={{ p: 2, maxWidth: 300 }}>
              <Typography variant="subtitle2" gutterBottom>
                Available Modes:{" "}
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>Manual Input: </strong> For updating a single mother's
                information ( name and phone number)
              </Typography>
              <Typography variant="body2">
                <strong>Upload Excel: </strong> For bulk updating multiple
                mothers information (name and phone number) using an Excel
                sheet.The excel sheet needs to have a column:{" "}
                <strong>Mother ID</strong>. The currently supported columns are
                "name" and "contact". The excel sheet needs to have{" "}
                <strong>"Name"</strong> or
                <strong>"Contact"</strong> column for the mother id that needs
                to be updated.
              </Typography>
            </Box>
          </Popover>
        </Box>
        {/* End Information */}

        <Stack direction="column" spacing={2}>
          <ButtonGroup variant="contained" fullWidth>
            {Object.entries(tabMap).map(([key, value]) => (
              <Button
                key={key}
                onClick={() => handleTabChange(key)}
                variant={activeTab === key ? "contained" : "outlined"}
              >
                {value}
              </Button>
            ))}
          </ButtonGroup>

          <Box>
            {activeTab === "MANUAL_INPUT" && (
              <UpdateManualInput setData={setData} handleClose={handleClose} />
            )}
            {activeTab === "EXCEL_UPLOAD" && (
              <UploadExcelSheet setData={setData} handleClose={handleClose} />
            )}
          </Box>
        </Stack>
      </ModalContent>
    </StyledModal>
  );
};

export default UpdateDataModal;
